import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { BottomSheetService } from "../services/bottomsheet.service";

@Injectable({
  providedIn: 'root'
})
export class ModalGuard {

  constructor(private dialogo: MatDialog,
    private bottomSheetService: BottomSheetService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
     
    return this.dialogo.openDialogs.length == 0 && this.bottomSheetService.getService() == null;

  }
}

export const canActivateGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(ModalGuard).canActivate(next, state);
}
